import {
  ViewEncapsulation, Component, ChangeDetectionStrategy, Input
} from '@angular/core';

import { User } from '@app/modules/core/interfaces/user';

@Component({
  selector: 'app-abandoned-reservation-header',
  templateUrl: './abandoned-reservation-header.component.html',
  styleUrls: ['./abandoned-reservation-header.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class AbandonedReservationHeaderComponent {

  @Input() user: User;
  @Input() translationType: string;

  constructor() { }

}
